function ComputerIcon({ width = '32', height = '28' }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 32 28"
    >
      <g id="noun-online-bank-401314" transform="translate(-146.597 -103.54)">
        <path
          id="Path_29669"
          data-name="Path 29669"
          d="M166.423,128.4h-7.653l-.272,1.406h-3.82v1.731h15.839v-1.731H166.7ZM175.3,103.54H149.9a3.313,3.313,0,0,0-3.3,3.319v16.928a3.313,3.313,0,0,0,3.3,3.318h25.4a3.313,3.313,0,0,0,3.3-3.318V106.859A3.315,3.315,0,0,0,175.3,103.54Zm1.58,17.812H148.319V106.859a1.586,1.586,0,0,1,1.579-1.588h25.4a1.586,1.586,0,0,1,1.58,1.588Z"
          fill="#3b4150"
        />
        <g
          id="noun-online-bank-401314-2"
          data-name="noun-online-bank-401314"
          transform="translate(0)"
        >
          <path
            id="Path_29669-2"
            data-name="Path 29669"
            d="M162.6,107.286a6.026,6.026,0,1,0,6,6.026A6.017,6.017,0,0,0,162.6,107.286Zm-.316,5.146a1.668,1.668,0,0,0,.548.339c.252.108.491.221.714.334a2.824,2.824,0,0,1,.581.394,1.631,1.631,0,0,1,.384.515,1.677,1.677,0,0,1,.137.707,1.553,1.553,0,0,1-.441,1.142,1.887,1.887,0,0,1-1.2.515v.822h-.647v-.826a2.055,2.055,0,0,1-1.361-.612,1.941,1.941,0,0,1-.474-1.364h1.371a1.067,1.067,0,0,0,.206.71.721.721,0,0,0,.584.244.576.576,0,0,0,.436-.165.634.634,0,0,0,.159-.458.752.752,0,0,0-.159-.508,1.515,1.515,0,0,0-.558-.347c-.265-.109-.511-.22-.736-.332a2.63,2.63,0,0,1-.583-.388,1.491,1.491,0,0,1-.374-.511,1.708,1.708,0,0,1-.13-.7,1.512,1.512,0,0,1,.463-1.139,1.993,1.993,0,0,1,1.237-.522v-.862h.647v.879a1.819,1.819,0,0,1,1.171.616,1.925,1.925,0,0,1,.424,1.282H163.3a1.121,1.121,0,0,0-.161-.654.593.593,0,0,0-.883-.059.692.692,0,0,0-.148.468.661.661,0,0,0,.171.484Z"
            fill="#d40e15"
          />
        </g>
      </g>
    </svg>
  );
}

export { ComputerIcon };
